import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutFirstCoownerLastNameChange = {
  onCheckoutFirstCoownerLastNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};

export default onCheckoutFirstCoownerLastNameChange;
